import {AnyAdapter} from './any-adapter.service';
import {CountAdapter} from './count-adapter.service';
import {NameIdAdapter} from './name-id-adapter.service';

export const Adapters = [AnyAdapter, CountAdapter, NameIdAdapter];
